// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `/**
 * DLC Identity Color Tokens
 *
 * Canonical source: see wiki/decisions/dlc-color-canon.md.
 * Locked at the .dlc-pill--{naplex,mpje,ptcb} surfaces in
 * frontend/src/components/ContentTray/ContentTray.css. Every other
 * DLC-coded surface (cards, prep nodes, dashboard fallbacks, modals,
 * upsells) MUST reference these tokens — never hardcode.
 *
 * Why three families:
 *   NAPLEX  green   #22c55e   -- learning, growth
 *   MPJE    blue    #3b82f6   -- legal/compliance, calm
 *   PTCB    amber   #fbbf24   -- technician, warning-adjacent (deeper bg #f59e0b)
 *
 * Usage:
 *   color: var(--dlc-naplex);
 *   background: rgba(var(--dlc-naplex-rgb), 0.12);
 *   border-color: rgba(var(--dlc-naplex-rgb), 0.35);
 */

:root {
  /* NAPLEX — green */
  --dlc-naplex: #22c55e;
  --dlc-naplex-hover: #34d399;
  --dlc-naplex-rgb: 34, 197, 94;

  /* MPJE — blue */
  --dlc-mpje: #3b82f6;
  --dlc-mpje-hover: #60a5fa;
  --dlc-mpje-rgb: 59, 130, 246;

  /* PTCB — amber */
  --dlc-ptcb: #fbbf24;
  --dlc-ptcb-hover: #fcd34d;
  --dlc-ptcb-rgb: 245, 158, 11;
}
`, "",{"version":3,"sources":["webpack://./src/styles/dlc-tokens.css"],"names":[],"mappings":"AAAA;;;;;;;;;;;;;;;;;;EAkBE;;AAEF;EACE,mBAAmB;EACnB,qBAAqB;EACrB,2BAA2B;EAC3B,6BAA6B;;EAE7B,gBAAgB;EAChB,mBAAmB;EACnB,yBAAyB;EACzB,4BAA4B;;EAE5B,iBAAiB;EACjB,mBAAmB;EACnB,yBAAyB;EACzB,4BAA4B;AAC9B","sourcesContent":["/**\n * DLC Identity Color Tokens\n *\n * Canonical source: see wiki/decisions/dlc-color-canon.md.\n * Locked at the .dlc-pill--{naplex,mpje,ptcb} surfaces in\n * frontend/src/components/ContentTray/ContentTray.css. Every other\n * DLC-coded surface (cards, prep nodes, dashboard fallbacks, modals,\n * upsells) MUST reference these tokens — never hardcode.\n *\n * Why three families:\n *   NAPLEX  green   #22c55e   -- learning, growth\n *   MPJE    blue    #3b82f6   -- legal/compliance, calm\n *   PTCB    amber   #fbbf24   -- technician, warning-adjacent (deeper bg #f59e0b)\n *\n * Usage:\n *   color: var(--dlc-naplex);\n *   background: rgba(var(--dlc-naplex-rgb), 0.12);\n *   border-color: rgba(var(--dlc-naplex-rgb), 0.35);\n */\n\n:root {\n  /* NAPLEX — green */\n  --dlc-naplex: #22c55e;\n  --dlc-naplex-hover: #34d399;\n  --dlc-naplex-rgb: 34, 197, 94;\n\n  /* MPJE — blue */\n  --dlc-mpje: #3b82f6;\n  --dlc-mpje-hover: #60a5fa;\n  --dlc-mpje-rgb: 59, 130, 246;\n\n  /* PTCB — amber */\n  --dlc-ptcb: #fbbf24;\n  --dlc-ptcb-hover: #fcd34d;\n  --dlc-ptcb-rgb: 245, 158, 11;\n}\n"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
export default ___CSS_LOADER_EXPORT___;
